import { ITicketGridsState } from "./types/ITicketGridsState";

export const initialState: ITicketGridsState = {
  loadingKeys: [],
  loadingReportKeys: [],
  updated: [],
  templates: [],
  filters: {
    status: -1,
  },
  loadingReports: false,
  ticketGridsCreating: false,
  errors: [],
  childTemplates: [],
  loadingChildTemplates: false,
};
